import {z} from 'zod'

const equipmentYardRawSchema = z.object({
    id: z.string(),
    name: z.string(),
    location_id: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    full_address: z.string().nullable(),
    active: z.boolean(),
})

export const equipmentYardSchema = equipmentYardRawSchema.transform((raw) => ({
    id: raw.id,
    name: raw.name,
    locationId: raw.location_id,
    latitude: raw.latitude,
    longitude: raw.longitude,
    fullAddress: raw.full_address,
    active: raw.active,
}))

export type EquipmentYardRaw = z.infer<typeof equipmentYardRawSchema>
export type EquipmentYard = z.infer<typeof equipmentYardSchema>

export const createEquipmentYardInputSchema = z.object({
    name: z.string().transform((value) => value.trim()),
    latitude: z.number(),
    longitude: z.number(),
    fullAddress: z.string().nullable(),
})

export type CreateEquipmentYardInput = z.input<typeof createEquipmentYardInputSchema>

export const createEquipmentYardRequestSchema = createEquipmentYardInputSchema.transform(
    ({name, latitude, longitude, fullAddress}) => ({
        name,
        latitude,
        longitude,
        full_address: fullAddress,
    }),
)

export type CreateEquipmentYardRequestRaw = z.infer<typeof createEquipmentYardRequestSchema>

export const updateEquipmentYardInputSchema = z.object({
    name: z
        .string()
        .transform((value) => value.trim())
        .optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    fullAddress: z.string().nullable().optional(),
    active: z.boolean().optional(),
})

export type UpdateEquipmentYardInput = z.input<typeof updateEquipmentYardInputSchema>

export const updateEquipmentYardRequestSchema = updateEquipmentYardInputSchema.transform(
    ({name, latitude, longitude, fullAddress, active}) => ({
        ...(name !== undefined ? {name} : {}),
        ...(latitude !== undefined ? {latitude} : {}),
        ...(longitude !== undefined ? {longitude} : {}),
        ...(fullAddress !== undefined ? {full_address: fullAddress} : {}),
        ...(active !== undefined ? {active} : {}),
    }),
)

export type UpdateEquipmentYardRequestRaw = z.infer<typeof updateEquipmentYardRequestSchema>
